export default {
  error: 'Sorry, something went wrong',
};
